import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import * as Sentry from "@sentry/react";
import AuthService from "../services/AuthService";

const AxiosHelper = {
  baseQueryWithRefresh: async (
    config: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    try {
      const token = localStorage.getItem("user-token");

      const configWithToken = {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios(configWithToken);
      return response;
    } catch (error: any) {
      if (error.response.status === 403) {
        AuthService.refreshToken();
        console.log("refreshing token");

        return await AxiosHelper.baseQueryWithRefresh(config);
      }
      Sentry.captureException(error);
      throw error;
    }
  },
};

export default AxiosHelper;
